<payarc-dialog-shell title="API token" (closed)="closeAction()">
  <payarc-detail-card [flat]="true" [rows]="detailRows"></payarc-detail-card>

  <div class="at-token-row">
    <div class="at-token-row__label">API/Bearer Token</div>
    <div class="at-token-box">
      <code>{{ data.token }}</code>
    </div>
  </div>

  <div footer>
    <button type="button" payarcButton="secondary" (click)="closeAction()">Cancel</button>
    <button type="button" payarcButton="primary" id="myTooltip" (click)="copy(data.token)">Copy</button>
  </div>
</payarc-dialog-shell>
